<script lang="ts">
	import { format } from 'svelte-i18n';
	import { rooms } from 'src/stores/lists/rooms';
	import {
		Text,
		Stack,
		AdvancedCard,
		Label,
		LabelList,
		AdvancedCardV2,
	} from '@Shelly/shelly-design-system';
	import DeviceInList from '../../Lists/Devices/DeviceInList.svelte';
	import { capFirstChar } from '../../../helpers/utilities';
	import { load_image_from } from 'src/helpers/interface_helpers';
	import { setSidePanelState } from 'src/components/Sidepanel/sidepanel-helpers';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let device, extSensor, extSensorValue, sensorIsOnline;

	let sensor = extSensor ? (extSensor?.sensor ? extSensor.sensor : extSensor) : undefined;
	let { name, label } = sensor || '';
	let room = $rooms[device?.room_id]?.name;
	let title = name || label,
		parentName = device.name,
		subtitle = { value: parentName, bold: false },
		description = { value: room },
		avatar = {
			image: device.image ? load_image_from(device.image, device?.server) : undefined,
			backgroundColor: device.backgroundColor || undefined,
		};

	$: label = { icon: 'fas fa-temperature-half', value: extSensorValue };

	const cardClick = () => {
		setSidePanelState({
			type: 'device',
			id: device.id,
			open: true,
		});
	};
</script>

<!-- TODO add translation "used_sensor" -->
<Text styleType="h2" class="mb-s">
	{capFirstChar($format('device_type_sensor', { default: 'sensor' }))}
</Text>

<Stack gap="s" class="mb-m">
	{#if !device?.deleted}
		{#if sensorIsOnline}
			{#if device.category === 'sensor' || device.category === 'thermostat'}
				{#key device}
					<DeviceInList {device} type={'group'} />
				{/key}
			{:else if $showNewLayout}
				<AdvancedCardV2
					aria-label={title}
					{avatar}
					{title}
					{subtitle}
					{description}
					isFocusable
					on:click={cardClick}
				>
					<svelte:fragment slot="right">
						<Label
							class="align-self-center"
							value={label.value}
							icon={label.icon}
							type="default"
							size={'l'}
						/>
					</svelte:fragment>
				</AdvancedCardV2>
			{:else}
				<AdvancedCard
					aria-label={title}
					{avatar}
					{title}
					{subtitle}
					{description}
					isFocusable
					on:click={cardClick}
				>
					<svelte:fragment slot="right">
						<Label
							class="align-self-center"
							value={label.value}
							icon={label.icon}
							type="default"
							size={'l'}
						/>
					</svelte:fragment>
				</AdvancedCard>
			{/if}
		{:else if $showNewLayout}
			<AdvancedCardV2
				aria-label={title}
				title={`${device?.name} - ${capFirstChar($format('label_offline'))}`}
				avatar={{
					image: device.image ? load_image_from(device.image, device?.server) : undefined,
					backgroundColor: device.backgroundColor || undefined,
					disabled: true,
				}}
				subtitle={{
					value: $format('alert_sensor_is_offline', {
						default: 'Sensor is offline',
					}),
					type: 'disabled',
				}}
			/>
		{:else}
			<AdvancedCard
				aria-label={title}
				title={`${device?.name} - ${capFirstChar($format('label_offline'))}`}
				avatar={{
					image: device.image ? load_image_from(device.image, device?.server) : undefined,
					backgroundColor: device.backgroundColor || undefined,
					disabled: true,
				}}
				subtitle={{
					value: $format('alert_sensor_is_offline', {
						default: 'Sensor is offline',
					}),
					type: 'disabled',
				}}
			/>
		{/if}
	{:else if $showNewLayout}
		<AdvancedCardV2
			isCondensed
			title={$format('missing_device_label', { default: 'Missing Device' })}
			avatar={{
				icon: 'text-warning fas fa-warning',
			}}
		>
			<svelte:fragment slot="main">
				<LabelList labelList={[{ value: device?.id, icon: 'fa-solid fa-microchip' }]} />
			</svelte:fragment>
		</AdvancedCardV2>
	{:else}
		<AdvancedCard
			isCondensed
			title={$format('missing_device_label', { default: 'Missing Device' })}
			avatar={{
				icon: 'text-warning fas fa-warning',
			}}
		>
			<svelte:fragment slot="main">
				<LabelList labelList={[{ value: device?.id, icon: 'fa-solid fa-microchip' }]} />
			</svelte:fragment>
		</AdvancedCard>
	{/if}
</Stack>
